import isOption from './isOption';

export default function getDisplayValue(value) {
	return isOption(value) ? value.label : '';
}
